<template>
  <div>
    <navbar back fixed>
      <span slot="title">办理房屋抵押须知</span>
    </navbar>
    <div class="page-content">
      <scroller ref="scroller">
        <div class="content">
          <div class="process">
            <h1 class="title">办理流程</h1>
            <div class="wraper-process">
              <div class="inner-process">
                <h3 class="inner-title">申请</h3>
                <div class="inner-txt">
                  登记申请人持申请材料到房屋登记部门申请房屋登记。
                </div>
              </div>
              <div class="inner-process">
                <h3 class="inner-title">受理</h3>
                <div class="inner-txt">
                  登记部门查验申请主体和申请材料，并就有关事项询问申请人。对准予受理的，出具受理通知书。
                </div>
              </div>
              <div class="inner-process">
                <h3 class="inner-title">领证</h3>
                <div class="inner-txt">
                  权利人或者申请房屋登记的代理人在房屋登记大厅领证窗口领取房屋权属证明书或登记证明。
                </div>
              </div>
            </div>
          </div>
          <div class="material">
            <h1 class="title">申报材料</h1>
            <div class="wraper-material">
              <div class="inner-material" :class="{hide: hideIdentity}">
                <h3 class="material-title">申请人身份证明</h3>
                <div class="inner-content">
                  <p class="inner-title">境内自然人：</p>
                  <div class="inner-txt">居民身份证，未成年人为居民身份证或户口簿；</div>
                  <p class="inner-title">中华人民共和国香港、澳门特别行政区自然人：</p>
                  <div class="inner-txt">香港、澳门特别行政区居民身份证或者香港、澳门特别行政区护照；</div>
                  <p class="inner-title">中华人民共和国台湾地区自然人：</p>
                  <div class="inner-txt">台湾居民来往大陆通行证；</div>
                  <p class="inner-title">华侨：</p>
                  <div class="inner-txt">中华人民共和国护照和国外长期居留身份证件；</div>
                  <p class="inner-title">外籍自然人：</p>
                  <div class="inner-txt">中国政府主管机关签发的居留证件或者其所在国护照、译文公证；</div>
                  <p class="inner-title">境内机关法人、事业单位法人、社团法人：</p>
                  <div class="inner-txt">组织机构代码证；</div>
                  <p class="inner-title">境内企业法人：</p>
                  <div class="inner-txt">企业法人营业执照；</div>
                  <p class="inner-title">境内其他组织：</p>
                  <div class="inner-txt">营业执照或者组织机构代码证；</div>
                  <p class="inner-title">境外（含港澳台，下同）法人、其他组织：</p>
                  <div class="inner-txt">其成立的批准文件，或注册证明，或商业登记证；</div>
                  <p class="inner-title">外国驻华使（领）馆和外国驻华办事机构、国际组织驻华代表机构：</p>
                  <div class="inner-txt">该使（领）馆、办事机构、代表机构出具的身份证明。</div>
                </div>
              </div>
              <div class="inner-btn" v-if="hideIdentity" @click="showIdentity">
                <div class="btn"><span class="iconfont">&#xe603;</span></div>
              </div>
            </div>
            <div class="wraper-material">
              <div class="inner-material" :class="{hide: hideApprove}">
                <h3 class="material-title">委托、公证和认证</h3>
                <div class="inner-content">
                  <div class="inner-txt-b">
                    委托代理人登记的，提交授权委托书、委托双方身份证明。授权委托书应当明确委托事项、权限；注明委托期限的，申请登记时间应当在委托期限内。委托人是法人或者其他组织的，应当加盖公章并注明日期；委托人是自然人的，应当签字并注明日期。授权委托书经公证的，可不再提交委托人的身份证明原件。
                  </div>
                  <div class="inner-txt-b">
                    抵押权（含最高额抵押权）设立登记中抵押人为自然人的（抵押权人为金融机构或者北京市住房贷款担保中心的除外），委托代理人代为申请的，应提交经公证的授权委托书。
                  </div>
                  <div class="inner-txt-b">
                    未成年人的房屋，应当由其监护人代为申请登记。监护人代为申请时，应当提交本人和未成年人的身份证明、监护关系证明,未成年子女及父母的户口本，因处分未成年人房屋申请登记的，监护人还应当提供为未成年人利益处分房屋的书面保证。父母之外其他监护人处分未成年人房屋申请登记的，其对未成年人享有监护权的证明应当经公证或者认证，但人民法院、居委会（村委会）或者未成年人父、母所在单位指定监护的除外。
                  </div>
                  <div class="inner-txt-b">
                    香港、澳门、台湾及外国申请人委托他人申请房屋登记的，其授权委托书应当经公证或者认证。其中，香港、澳门地区出具的公证书应当由中国法律服务(香港或者澳门)有限公司加盖转递专用章；台湾地区出具的公证书应当由北京市公证协会确认；外国出具的公证文书应当经中国驻该国使(领)馆认证，与中国没有外交关系的国家，应当经该国和中国都有外交关系的第三国的中国使(领)馆认证。
                  </div>
                  <div class="inner-txt-b">
                    除委托、声明、遗嘱等单方法律行为外，其他涉及房屋的公证应当由本市公证机构出具。
                  </div>
                  <div class="inner-txt-b">
                    当事人约定合同经公证生效的，应当提交有关合同的公证文书原件。
                  </div>
                </div>
              </div>
              <div class="inner-btn" v-if="hideApprove" @click="showApprove">
                <div class="btn"><span class="iconfont">&#xe603;</span></div>
              </div>
            </div>
            <div class="wraper-material">
              <div class="inner-material" :class="{hide: hideOther}">
                <h3 class="material-title">其他要求</h3>
                <div class="inner-content">
                  <div class="inner-txt-b">
                    申请材料注明原件的，申请人应当提交申请材料原件。申请材料未注明原件的，申请人应当提交申请材料复印件，并提供申请材料原件供登记部门核验。要求提交申请材料原件，申请人不能提交原件的，可以提交出具该原件的机关或者法定存档机构确认与原件一致的复印件，或者公证机构公证的复印件与原件一致的证明。
                  </div>
                  <div class="inner-txt-b">
                    房屋登记申请书应当由申请人（代理人）签字确认。申请人是法人或者其他组织的，由代理人签字，可不加盖公章；申请人是自然人的，由申请人（代理人）签字。
                  </div>
                  <div class="inner-txt-b">
                    申请登记材料应当使用汉字文本，外文文本的申请材料应当附经公证或认证的汉字译本。<br>
                    <span>（填写申请材料应当使用黑色或者蓝黑色钢笔、签字笔，书写内容清晰工整，不得使用修正液等进行修改。确需修改的，申请人应当在修改处签字确认。）</span>
                  </div>
                  <div class="inner-txt-b">
                    申请人应当就有关事项接受登记部门询问并如实回答，在确认询问结果后，在询问笔录上签署姓名和日期。代理人代为接受询问的，代理人应当明确代某个申请人接受询问。
                  </div>
                  <div class="inner-txt-b">
                    共有的房屋，应当由共有人共同申请登记。共有人应当书面约定共有方式；按份共有的，还应当明确共有人各自占有的份额。夫妻共同申请房屋登记的，应提交婚姻关系证明。<br>
                    <span>（婚姻关系证明应当为《结婚证》。无法提供《结婚证》的，申请人应当向婚姻登记部门申请补领。无法补领的，可提供婚姻登记部门出具的婚姻登记证明，或者经公证（或者认证）的婚姻状况证明，或者有权部门出具的证明材料。）</span>
                  </div>
                  <div class="inner-txt-b">
                    以下材料可作为监护关系证明使用：户口簿、婚姻关系证明；出生医学证明；人民法院指定监护人的生效判决；居民委员会、村民委员会指定监护人的证明文件；证明监护关系的公证书；未成年人的父、母的所在单位指定监护人的证明文件。
                  </div>
                  <div class="inner-txt-b">
                    用于申请房屋登记的境外司法文书应当经有管辖权的北京市中级人民法院裁定予以认可和执行。<br>
                    <span>（各区的执行标准会有差异，具体参照各区要求或咨询各区专员）</span>
                  </div>
                </div>
              </div>
              <div class="inner-btn" v-if="hideOther" @click="showOther">
                <div class="btn"><span class="iconfont">&#xe603;</span></div>
              </div>
            </div>
          </div>
        </div>
      </scroller>
    </div>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Scroller from 'components/scroller/scroller'

  export default {
    data () {
      return {
        hideIdentity: true,
        hideApprove: true,
        hideOther: true
      }
    },
    mounted () {
      this._refresh()
    },
    methods: {
      showIdentity () {
        this.hideIdentity = false
        this._refresh()
      },
      showApprove () {
        this.hideApprove = false
        this._refresh()
      },
      showOther () {
        this.hideOther = false
        this._refresh()
      },
      _refresh () {
        this.$nextTick(() => {
          if (this.$refs.scroller) {
            setTimeout(() => {
              this.$refs.scroller.resize()
            }, 500)
          }
        })
      }
    },
    components: {Navbar, Scroller}
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  .page-content
    background-color #1b446a
    background-image url(../../../static/images/bg-main.png)
    background-repeat repeat

  .content
    padding 0 1em
    font-size px2rem(26)
    color: #fff

    .inner-txt
      text-align justify
      line-height 1.4

    .process
      position relative

      .title
        display inline-block
        margin px2rem(26) 0 px2rem(20)
        padding 2px 6px
        font-size px2rem(26)
        font-weight normal
        line-height 1.4
        border-radius 4px
        background-color #13a0df

      .wraper-process
        padding-bottom px2rem(40)
        margin-left 13px

        .inner-process
          position relative
          border-left 1px solid #1d4a74
          padding-left px2rem(15)
          padding-bottom px2rem(50)
          &:last-child
            padding-bottom 0
          &:before
            content ''
            position absolute
            left px2rem(-7)
            width px2rem(12)
            height px2rem(12)
            border-radius 50%
            border px2rem(4) solid #13a0df

          .inner-title
            position absolute
            margin px2rem(-10) 0 0
            font-size px2rem(28)
            color #13a0df
          .inner-txt
            padding-top px2rem(25)

    .material
      position relative

      .title
        display inline-block
        margin 0 0 px2rem(20)
        padding 2px 6px
        font-size px2rem(26)
        font-weight normal
        line-height 1.4
        border-radius 4px
        background-color #275482

      .wraper-material
        margin-left 5px

        p
          margin 0

        .inner-material
          height auto
          overflow hidden
          padding-bottom px2rem(40)
          transition all .35s ease-in-out
          &.hide
            height px2rem(100)
        .material-title
          margin 0 0 px2rem(20)
          font-size px2rem(28)
          color #a0b751

        .inner-content
          position relative
          left 8px
          border-left 1px solid #1d4a74
          padding-left px2rem(15)

          .inner-title
            position absolute
            margin px2rem(-10) 0 0
            &:last-child
              padding-right 10px

            &:before
              content ''
              position absolute
              top px2rem(9)
              left px2rem(-22)
              width px2rem(12)
              height px2rem(12)
              border-radius 50%
              border px2rem(4) solid #13a0df

          .inner-txt
            padding-top px2rem(19)
            padding-bottom px2rem(50)
            padding-right 10px
            &:last-child
              padding-top px2rem(49)
              padding-bottom 0

          .inner-txt-b
            position relative
            margin px2rem(-10) 0 0
            padding-bottom px2rem(50)
            padding-right 10px
            line-height 1.4
            &:last-child
              padding-bottom 0

            &:before
              content ''
              position absolute
              top px2rem(9)
              left px2rem(-22)
              width px2rem(12)
              height px2rem(12)
              border-radius 50%
              border px2rem(4) solid #13a0df

            & span
              font-size px2rem(22)
              font-weight 600

        .inner-btn
          position relative
          height px2rem(140)
          margin-top px2rem(-65)
          text-align center
          font-size px2rem(60)
          color #13a0df

          .btn
            position absolute
            bottom 0
            width 100%
            box-shadow 0 px2rem(-12) px2rem(15) #1b446a
</style>



// WEBPACK FOOTER //
// instructions.vue?74a5f894